export default {
  design: {
    title: 'Concept',
  },

  detail: {
    leaveConfirmation: 'Êtes-vous sûr de vouloir partir? Tous les ajustements seront perdus.',
    leaveTitle: 'Confirmation',
  },

  filters: {
    cw_class_kettle: 'Chaudière de chauffage central de classe CW',
    gas_connection_type: 'Type de connexion de gaz',
    heat_pump_power: 'Puissance de la pompe à chaleur',
    heat_pump_series: 'Série de pompe à chaleur',
    heat_pump_type: 'Type de pompe à chaleur',
    kettle_series: 'Série Bouilloire',
    kettle_type: 'Type de bouilloire',
  },

  info: {
    products: 'Produits principaux dans cette configuration',
    sap: 'Code de commande',
    select: 'Sélectionner le système',
  },

  overview: {
    noData: 'Aucun système trouvé',
  },

  quote: {
    calculation: {
      subtotalExclVAT: 'Sous-total (HTVA):',
      subtotalInclVAT: 'Sous-total (TVA incl.):',
      total: 'Total:',
      vat: 'TVA:',
    },
    columns: {
      amount: 'Nombre',
      price: 'Prix',
      name: 'Nom',
      serial_number: 'Code de commande',
      subtotal: 'Sous-total',
      vat_percentage: 'TVA %',
      vat_total: 'TVA €',
    },
    system: 'Système',
    title: 'Offre',
  },

  share: {
    addMessage: 'Ajouter un message',
    billMaterials: 'Enumération de matériel',
    date: 'Date',
    defaultMessage: 'Cher, \n\nVeuillez trouver la proposition en pièce jointe de cet e-mail.\nNous restons à votre disposition pour répondre à toutes vos questions. \n\nCordialement,',
    download: 'Télécharger',
    editSubject: 'Adaptez le sujet de l\'e-mail',
    editSubjectPlaceholder: 'Remplir le sujet de l\'e-mail',
    emailPlaceholder: 'Entrer une adresse e-mail',
    failure: 'Quelque chose est mal passé. Veuillez réessayer plus tard.',
    loading: 'Chargement en cours...',
    quote: 'Offre',
    quoteNumber: 'Numéro du devis',
    sendDuplicate: 'Envoyez-moi une copie',
    shareViaMail: 'Partager par e-mail',
    success: 'Le projet a été envoyé avec succès.',
    systemSketch: 'Croquis du système',
    title: 'Partager',
    totalAmount: 'Nombre total',
    validUntil: 'Valable jusqu\'au',
  },

  sorting: {
    nameAsc: 'Nom A - Z',
    nameDesc: 'Nom Z - A',
    priceAsc: 'Prix bas - haut',
    priceDesc: 'Prix haut - bas',
  },

  title: 'Systèmes',

};



// WEBPACK FOOTER //
// ./js/lang/fr/systems.js